import React from "react";
import {
  RotaTable,
  THead,
  TrHead,
  TBody,
  Th,
  Tr,
  Td,
  InnerCell,
  RotaButtonIcon,
  iconNew
} from "@teamrota/rota-design";

import { EmptyText } from "~/src/components/payroll/style";
import { PayrollRate } from "./types";
import { formatDateFull } from "~/src/utils/formatting";

const { Edit, Info } = iconNew;

type TableProps = {
  payrollRates: PayrollRate[];
  handleOpenRate: (id: string) => void;
  canEdit: boolean;
};

const Table = ({ payrollRates, handleOpenRate, canEdit }: TableProps) => {
  return (
    <RotaTable>
      <THead>
        <TrHead>
          <Th>Name</Th>
          <Th>User</Th>
          <Th>Created at</Th>
          <Th>Last edited</Th>
          <Th>Action</Th>
        </TrHead>
      </THead>

      <TBody>
        {payrollRates?.length ? (
          payrollRates.map((rate: PayrollRate) => (
            <Tr key={rate.id}>
              <Td>
                <InnerCell>{rate.name}</InnerCell>
              </Td>
              <Td>
                <InnerCell>USER</InnerCell>
              </Td>
              <Td>
                <InnerCell>{formatDateFull(rate.createdAt)}</InnerCell>
              </Td>
              <Td>
                <InnerCell>
                  {rate.updatedAt && formatDateFull(rate.updatedAt)}
                </InnerCell>
              </Td>
              <Td>
                <InnerCell>
                  <RotaButtonIcon
                    onClick={() => handleOpenRate(rate.id)}
                    style={{ margin: "auto" }}
                  >
                    {canEdit ? <Edit /> : <Info />}
                  </RotaButtonIcon>
                </InnerCell>
              </Td>
            </Tr>
          ))
        ) : (
          <Tr>
            <Td colSpan={5}>
              <EmptyText>Nothing to see here 👀 Try clicking Create!</EmptyText>
            </Td>
          </Tr>
        )}
      </TBody>
    </RotaTable>
  );
};

export default Table;
